module.exports = "/img/volkswagen.4717ab44.png";